import React from 'react';
import classnames from 'classnames';
import uuidv1 from 'uuid/v1';
import { Notification, Icon } from 'grab-ui';
import { isNil } from 'common/utils/data-utils';

import css from './notification.less';

export const NOTIFICATION_TYPE = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
  INFO: 'INFO',
};

const getNotificationContent = (type, title, content, time) => {
  let icon;
  if (type === NOTIFICATION_TYPE.SUCCESS) {
    icon = <Icon type="check-circle" className={css.icon} />;
  } else if (
    type === NOTIFICATION_TYPE.ERROR ||
    type === NOTIFICATION_TYPE.INFO
  ) {
    icon = <Icon type="exclamation-circle" className={css.icon} />;
  }
  return {
    message: title,
    description: (
      <div>
        {content}
        {time && <h6 className={css.time}>{time} </h6>}
      </div>
    ),
    icon,
  };
};

export const addNotification = ({
  id,
  type = NOTIFICATION_TYPE.ERROR,
  title,
  content,
  time,
  onClick,
  duration = null,
  clickable = false,
}) => {
  const notifIds = Object.keys(window.notificationQueue);
  const notifQuantity = notifIds.length;
  const notifId = isNil(id) ? uuidv1() : id;
  const classNames = [css.notification];
  if (notifQuantity >= 5) {
    const firstNotif = notifIds[0];
    Notification.close(firstNotif);
    delete window.notificationQueue[firstNotif];
  }

  if (type === NOTIFICATION_TYPE.SUCCESS) {
    classNames.push(css.successNotification);
  } else if (type === NOTIFICATION_TYPE.INFO) {
    classNames.push(css.infoNotification);
  } else {
    classNames.push(css.errorNotification);
  }

  if (clickable) {
    classNames.push(css.clickableNotification);
  }

  Notification.open({
    key: notifId,
    ...getNotificationContent(type, title, content, time),
    onClose: () => {
      delete window.notificationQueue[notifId];
    },
    duration,
    className: classnames(...classNames),
    onClick,
  });

  window.notificationQueue[notifId] = notifId;
};

export const removeNotification = id => {
  if (window.notificationQueue[id]) {
    delete window.notificationQueue[id];
    Notification.close(id);
  }
};
